
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19 13H5a3 3 0 01-3-3V6a3 3 0 013-3h14a3 3 0 013 3v4a3 3 0 01-3 3zm-2 5.116c-2.843-2.22-6.907-2.22-9.75 0m2.03 2.84a4.654 4.654 0 015.688 0M18 6h-2","stroke":"#50657c","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M18 13v-1a2 2 0 00-2-2H8a2 2 0 00-2 2v1","stroke":"#50657c","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    